import {
  AgeBand,
  ResponseEnum,
  type ShopOptionRequest,
  type ShopResponse,
} from "@b2bportal/rbc-activities-api";
import { activitiesApi } from "@overrides/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { ActivitiesShopActions, type ShopSearch } from "..";
import type { ActivitiesState } from "../../../../store";
import { fetchActivitiesShopOption } from "./fetchActivitiesShopOption";

export type FetchShopFulfillResponse = {
  shop: ShopResponse;
  search: ShopSearch;
};

export const fetchActivitiesShop = createAsyncThunk<
  FetchShopFulfillResponse,
  { search: ShopSearch },
  { state: ActivitiesState; rejectValue: { error: string } }
>("activitiesShop/fetchActivitiesShop", async ({ search }, thunkAPI) => {
  try {
    const shopRes = await activitiesApi.apiV0ActivitiesShopPost({
      id: { value: search.activityId },
      dateRange: search.dateRange,
    });

    const shop = shopRes.data;

    // After successful shop call, automatically fetch shop option with from date and 1 adult
    if (shop.Response === ResponseEnum.Success) {
      const activity = shop.value;
      const selectedDate = dayjs(search.dateRange.from).format("YYYY-MM-DD");
      const bookableItem = activity.bookableItems[0];

      const shopOptionRequest: ShopOptionRequest = {
        activityId: activity.id,
        date: selectedDate,
        timeSlotPrices: bookableItem?.timeSlotsByDate?.[selectedDate] ?? [],
        ageBandPrices: bookableItem?.ageBandPricesByDate?.[selectedDate] ?? [],
        paxMix: [{ ageBand: AgeBand.Adult, numberOfTravelers: 1 }],
        currency: activity.bestPrice.fiat.currencyCode,
        shopPricingOpaque: activity.pricingOpaque,
        shopContext: activity.shopContext,
        activityOptionId: bookableItem?.optionId,
      };

      thunkAPI.dispatch(
        fetchActivitiesShopOption({ request: shopOptionRequest })
      );
    }

    return {
      shop,
      search,
    };
  } catch (error) {
    thunkAPI.dispatch(ActivitiesShopActions.setActivityUnavailable(true));
    return thunkAPI.rejectWithValue({ error: String(error) });
  }
});
